import React, { useState, useEffect, useRef } from "react";
import "./form.css"; // Ensure the CSS path is correct
import { useTranslation } from "react-i18next";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  MDBInput,
  MDBCol,
  MDBRow,
  MDBCheckbox,
  MDBBtn,
  MDBIcon,
} from "mdb-react-ui-kit";

const Form = () => {
  const { t } = useTranslation();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [message, setMessage] = useState("");
  const [todayDate, setTodayDate] = useState(
    new Date().toLocaleDateString("en-CA")
  );
  const form = useRef();

  const sendEmail = async (e) => {
    e.preventDefault(); // Prevent default form submission

    if (!email || !lastName || !firstName || !contactNumber) {
      // Validation for empty fields
      toast.error("Please fill in all required fields.", {
        position: "top-center",
      });
      return;
    }

    emailjs
      .sendForm(
        "service_iv0ubpj", // Replace with your EmailJS service ID
        "template_55ht4ji", // Replace with your EmailJS template ID
        form.current, // Reference to the form
        "2EsV4s5_OkN1AkxTa" // Replace with your EmailJS public key
      )
      .then(
        (result) => {
          console.log("SUCCESS!", result.text);
          toast.success("Form submitted successfully!", {
            position: "top-center",
          });

          // Reset form fields
          setFirstName("");
          setLastName("");
          setEmail("");
          setContactNumber("");
          setMessage("");
        },
        (error) => {
          console.error("FAILED...", error.text);
          toast.error("Failed to send email. Please try again later.", {
            position: "top-center",
          });
        }
      );
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        toastStyle={{
          backgroundColor: "white",
          fontFamily: "poppins",
          fontSize: "15px",
        }}
        progressStyle={{ background: "red", opacity: "unset" }}
      />

      {/* <iframe src="https://landtrack.pk" style={{ width: '100%', height: '', border: 'none' }}></iframe> */}
      <section id="form_section">
        <div id="form_txt_div">
          <h5 id="form_sbhdng">{t("contact.sub_heading")}</h5>
          <h1 id="form_hdng">{t("contact.main_heading")}</h1>

          <p id="form_txt">{t("contact.text")}</p>
        </div>

        <div id="form_div">
          <form ref={form} id="form" onSubmit={sendEmail}>
            <MDBRow className="mb-4">
              <MDBCol id="field">
                <MDBInput
                  value={firstName}
                  name="firstName"
                  onChange={(e) => setFirstName(e.target.value)}
                  id="first_name_input"
                  label="First Name"
                />
              </MDBCol>
              <MDBCol>
                <MDBInput
                  value={lastName}
                  name="lastName"
                  onChange={(e) => setLastName(e.target.value)}
                  id="last_name_input"
                  label="Last name"
                />
              </MDBCol>
            </MDBRow>
            <MDBInput
              value={email}
              name="email"
              onChange={(e) => setEmail(e.target.value)}
              className="mb-4"
              type="email"
              id="email_input"
              label="Email address"
            />
            <MDBInput
              value={contactNumber}
              name="contactNumber"
              onChange={(e) => setContactNumber(e.target.value)}
              className="mb-4"
              type="number"
              id="phone_input"
              label="Contact No."
            />
            <MDBInput
              value={message}
              name="message"
              onChange={(e) => setMessage(e.target.value)}
              className="mb-4"
              type="text"
              id="msg_input"
              label="Your Message"
            />

            <MDBBtn
              type="submit"
              className="mb-4 submit_btn"
              block
              id="form_btn"
            >
              Submit
            </MDBBtn>
          </form>
        </div>
      </section>
    </>
  );
};

export default Form;
